import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'carousel-component',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements AfterViewInit, OnChanges {
  @Input() dotsAmount: number;

  @ContentChild('header') header: TemplateRef<void>;
  @ContentChild('scrollable') scrollable: TemplateRef<void>;
  @ViewChild('scroller') scroller: ElementRef;

  dots: number[];
  activeTableIndex = 0;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dotsAmount?.previousValue !== changes.dotsAmount?.currentValue) {
      this.dots = new Array(changes.dotsAmount?.currentValue).fill(0);
    }
  }

  ngAfterViewInit() {
    this.scroller?.nativeElement?.addEventListener('scroll', event => this.scrollHandler(event, this));
  }

  scrollToIndex(index: number) {
    const { scrollLeft, offsetWidth } = this.scroller?.nativeElement || {};
    if (scrollLeft !== index * offsetWidth) {
      this.activeTableIndex = index;
      this.scroller?.nativeElement?.scrollTo({
        left: index * offsetWidth,
      });
    }
  }

  scrollHandler({ target }, context: CarouselComponent) {
    const { scrollLeft, offsetWidth } = target;

    const atSnappingPoint = scrollLeft % offsetWidth === 0;
    const timeOut = atSnappingPoint ? 0 : 150;
    setTimeout(() => {
      if (!timeOut) {
        context.activeTableIndex = scrollLeft / offsetWidth;
      }
    }, timeOut);
  }
}
